import { render, staticRenderFns } from "./BranchsProductList.vue?vue&type=template&id=6164a49e"
import script from "./BranchsProductList.vue?vue&type=script&lang=js"
export * from "./BranchsProductList.vue?vue&type=script&lang=js"
import style0 from "./BranchsProductList.vue?vue&type=style&index=0&id=6164a49e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports